"use client";

import { usePathname } from "next/navigation";
import { useEffect } from "react";
import { create } from "zustand";

interface AsPathStoreType {
  prevAsPath: string | undefined;
  currentAsPath: string | undefined;
  setAsPaths: (_prev: string | undefined, _current: string | undefined) => void;
}

const useAsPathStore = create<AsPathStoreType>((set) => ({
  prevAsPath: undefined,
  currentAsPath: undefined,
  setAsPaths: (prev, current) =>
    set({ prevAsPath: prev, currentAsPath: current }),
}));

/** Hook to get prevAsPath and currentAsPath */
export const useAsPath = () => useAsPathStore((state) => state);

/** Get the current state outside of React components */
export const getAsPath = () => useAsPathStore.getState();

/** Initializes prevAsPath and currentAsPath (use in layout or Client Provider) */
export const useAsPathInitializer = () => {
  const pathname = usePathname();
  const { currentAsPath, setAsPaths } = useAsPathStore();

  useEffect(() => {
    if (currentAsPath !== pathname) {
      setAsPaths(currentAsPath, pathname);
    }
  }, [pathname, currentAsPath, setAsPaths]);
};

export default useAsPathStore;
